<template>
  <div
    class="q-uploader painel-arquivo"
    style="width: 100%; box-shadow: none; overflow: hidden"
    @dragover="aoArrastarSobre"
    @drop="aoSoltar"
    @dragleave="aoSairArrastando"
    @mouseover="aoPassarMouse"
    @mouseleave="aoTirarMouse"
  >
    <div class="q-uploader__header">
      <div class="header-upload">
        <div :class="$q.platform.is.mobile ? 'layout-responsive' : 'layout'">
          <div v-if="!$q.platform.is.mobile">
            <div class="q-uploader__title">Selecione um arquivo</div>
          </div>
          <div class="icones-layout">
            <label v-if="$q.platform.is.mobile">
              <i class="material-icons" style="font-size: 20px; cursor: pointer;">add_a_photo</i>
              <!-- `ref` e nao `id`: os dois inputs nasceram com id="file" duplicado, e
                   um click() programatico acertava sempre o primeiro do documento. -->
              <input
                ref="inputCamera"
                accept="image/*"
                capture="camera"
                type="file"
                style="width: 0"
                class="file"
                @change="aoEscolherArquivo"
              />
            </label>
            <label>
              <i class="material-icons" style="font-size: 20px; cursor: pointer">cloud_upload</i>
              <input
                ref="inputArquivo"
                type="file"
                style="width: 0"
                class="file"
                accept="image/*"
                @change="aoEscolherArquivo"
              />
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="q-uploader__list scroll" style="border: 1px solid #ccc;">
      <div v-for="(upload, i) in uploads" :key="upload.fileName + '-' + i" style="margin-bottom: 8px">
        <div class="q-uploader__file relative-position">
          <div class="q-uploader__file-header row flex-center no-wrap">
            <i
              v-if="upload.error"
              aria-hidden="true"
              class="material-icons q-icon text-negative q-uploader__file-status"
            >warning</i>
            <div
              class="q-uploader__file-header-content col"
              v-if="!upload.processing"
              style="cursor: pointer"
              @click="$emit('arquivo-revisado', upload)"
            >
              <div class="q-uploader__title">{{ upload.fileName }}</div>
              <div class="q-uploader__subtitle row items-center no-wrap">
                {{ upload.fileSize }} / {{ upload.progress }}
              </div>
            </div>
            <q-btn round dense flat icon="clear" :loading="upload.uploading" @click="$emit('arquivo-removido', i)">
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>
          </div>
        </div>
      </div>

      <q-list dense bordered separator>
        <q-item
          v-for="(arquivo, i) in arquivos"
          :key="i"
          clickable
          v-ripple
          :active="!!reviewingFile && reviewingFile.id == arquivo.id"
        >
          <q-item-section @click="$emit('arquivo-revisado', arquivo)">{{ arquivo.nome }}</q-item-section>
          <q-btn
            round
            dense
            flat
            icon="clear"
            :loading="carregando && carregandoImgId == arquivo.id"
            @click="$emit('arquivo-removido', arquivo)"
          >
            <template v-slot:loading>
              <q-spinner color="grey-10" size="1em" />
            </template>
          </q-btn>
        </q-item>
      </q-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "painel-arquivo",

  emits: ["arquivo-removido", "arquivo-revisado", "arquivo-selecionado"],
  props: {
    uploads: { type: Array, default: () => [] },
    arquivos: { type: Array, default: () => [] },
    reviewingFile: { type: Object, default: null },
    carregando: { type: Boolean, default: false },
    carregandoImgId: { default: null }
  },
  methods: {
    // Chamado pela casca ao entrar na aba pela primeira vez. O seletor so abre a
    // partir de um gesto do usuario (o clique na aba), por isso quem decide
    // *quando* e a casca, que conhece o ciclo de vida do modal.
    abrirSeletor() {
      const input = this.$q.platform.is.mobile ? this.$refs.inputCamera : this.$refs.inputArquivo;
      if (input && typeof input.click === "function") {
        input.click();
      }
    },
    aoEscolherArquivo(event) {
      const arquivos = event.target.files;
      if (!arquivos || !arquivos.length) return;
      this.$emit("arquivo-selecionado", arquivos);
    },
    aoSoltar(event) {
      event.stopPropagation();
      event.preventDefault();
      const arquivos = event.dataTransfer && event.dataTransfer.files;
      if (!arquivos || !arquivos.length) return;
      this.$emit("arquivo-selecionado", arquivos);
    },
    // O codigo original lia a global `event` implicita; fora do arquivo de origem
    // isso e ainda mais fragil, entao o evento vem por parametro.
    aoArrastarSobre(event) {
      event.preventDefault();
    },
    aoSairArrastando(event) {
      event.preventDefault();
    },
    aoPassarMouse(event) {
      event.preventDefault();
    },
    aoTirarMouse(event) {
      event.preventDefault();
    }
  }
};
</script>

<style lang="stylus" scoped>
.layout
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:10px 10px;

.layout-responsive
  text-align:center;
  padding:10px 10px;

.layout-responsive .icones-layout label
  padding:3rem;

.icones-layout label
  margin-right:5px;

</style>
